import React from 'react';
import StatusChip from '../Elements/StatusChip';

const StatusField = ({ style, ...props}) =>(
    <div style={style}>
        {props.value==='Active'
            ? <StatusChip tone="ok" dot>Активен</StatusChip>
            : <StatusChip tone="danger" dot>Заблокирован</StatusChip>
        }
    </div>
)

export default StatusField;
